import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIIcon from 'UIComponents/icon/UIIcon';
import { trackClickSubmitForecastFromDealTable } from '../../utils/usageTracker';
import { useSubmitForecastDisabledTooltipTitle } from './hooks/useSubmitForecastDisabledTooltipTitle';
import { getShowSubmissionPanelFromDealTable } from '../../selectors/dealsSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SubmitForecastBulkActionButton = ({
  isDealStageView,
  onSubmitForecastFromTable
}) => {
  const isSubmissionPanelOpen = useSelector(getShowSubmissionPanelFromDealTable);
  const handleClick = () => {
    onSubmitForecastFromTable();
    trackClickSubmitForecastFromDealTable(isDealStageView);
  };
  const submitForecastDisabledTooltipTitle = useSubmitForecastDisabledTooltipTitle();
  if (isSubmissionPanelOpen) {
    return null;
  }
  return /*#__PURE__*/_jsx(UITooltip, {
    placement: "bottom",
    disabled: !submitForecastDisabledTooltipTitle,
    title: submitForecastDisabledTooltipTitle,
    children: /*#__PURE__*/_jsxs(UIButton, {
      use: "transparent",
      "data-test-id": "submit-forecast-bulk-action-button",
      disabled: !!submitForecastDisabledTooltipTitle,
      onClick: handleClick,
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "next"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dealTable.bulkActions.submitForecast"
      })]
    })
  });
};
export default SubmitForecastBulkActionButton;